import React from "react";
import ShopHeader from "./ShopHeader";
import { Loading } from "../../App";
import queryString from "query-string";
import { Helmet } from "react-helmet/es/Helmet";
import logo from "../../images/logo.png";
import Searchproduct from "../search/Searchproduct";
import Ajax, { domain } from "../../ajax/Ajax";
import Products from "../products/Products";
import BottomScrollListener from "react-bottom-scroll-listener";
import { Link, Route } from "react-router-dom";
import ProductDetails from "../products/ProductDetails";
import OrderProduct from "../order/OrderProduct";
import ShoppingCartQtyForm from "../shoppingcart/ShoppingCartQtyForm";
import ShoppingCart from "../shoppingcart/ShoppingCart";

export class Shop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      shop: null,
      shopId: null,
      search: null,
      searching: false,
      products: null,
      fetching: false,
      prevFetch: null,
      nextFetch: null,
      initialFetchMade: false,
      shoppingCart: localStorage.getItem("shoppingCart")
        ? JSON.parse(localStorage.getItem("shoppingCart"))
        : null,
    };

    this.renderShopContent = this.renderShopContent.bind(this);
    this.fetchShopDetails = this.fetchShopDetails.bind(this);
    this.fetchProducts = this.fetchProducts.bind(this);
    this.fetchMoreProducts = this.fetchMoreProducts.bind(this);
    this.updateShoppingCart = this.updateShoppingCart.bind(this);
    this.checkQueryParams = this.checkQueryParams.bind(this);
  }

  updateShoppingCart(cart) {
    this.setState({
      shoppingCart: cart,
    });
    localStorage.setItem("shoppingCart", JSON.stringify(cart));
  }

  checkQueryParams() {
    try {
      let params = queryString.parse(this.props.location.search);
      if (params) {
        if (params.search && this.state.shop) {
          if (!(params.search === this.state.search)) {
            this.setState(
              {
                search: params.search,
                searching: true,
              },
              this.fetchProducts
            );
          }
        }
      }
    } catch (e) {}
  }

  async fetchMoreProducts() {
    if (!this.state.fetching) {
      let url =
        domain + this.state.nextFetch.replace("http://127.0.0.1:8001", "");
      console.log("fetching more ...");
      this.setState({ fetching: true });
      let fetchResults = await Ajax.fetchData(url);

      if (fetchResults) {
        let currentProducts = this.state.products;
        fetchResults.results.forEach((product) => {
          currentProducts.push(product);
        });
        await this.setState({
          products: currentProducts,
          nextFetch: fetchResults.next,
          prevFetch: fetchResults.previous,
          fetching: false,
        });
      }
    }
  }

  async fetchProducts() {
    let param = "";
    if (this.state.location) {
      param = `lat=${this.state.location.lat}&lon=${this.state.location.lon}`;
    }
    if (this.state.search) {
      param += "&search=" + this.state.search;
    }

    param += "&shop=" + this.state.shopId;

    let url = domain + "/en/api/market/v1/?" + param;

    let fetchResults = await Ajax.fetchData(url);
    console.log(fetchResults, "the fetch results");

    if (fetchResults) {
      await this.setState({
        products: fetchResults.results,
        nextFetch: fetchResults.next,
        prevFetch: fetchResults.previous,
        initialFetchMade: true,
        fetchMore: false,
        fetching: false,
        searching: false,
      });
    }
  }

  renderShopContent() {
    if (this.state.ready) {
      return (
        <div>
          {this.state.shop ? (
            <Helmet>
              <link rel="icon" href={logo} />
              <title>{this.state.shop.name}</title>
            </Helmet>
          ) : (
            <div></div>
          )}
          <ShopHeader shop={this.state.shop} />
          <div className="container">
            <Searchproduct
              location={this.props.location}
              history={this.props.history}
              searching={this.state.searching}
              search={this.state.search}
              placeholder={"Search " + this.state.shop.name}
            />
          </div>

          <div>
            {this.state.products ? (
              <div className="mt-4 container">
                <Products shop={true} products={this.state.products} />
              </div>
            ) : (
              <div className="mt-4">
                <Loading />
              </div>
            )}
          </div>

          <div>
            <Route
              path="/shop-at/:shopName/:shopId/product/"
              render={(props) => (
                <ProductDetails {...props} shop={this.state.shop} />
              )}
            />
            <Route
              path="/shop-at/:shopName/:shopId/order/"
              render={(props) => (
                <OrderProduct {...props} shop={this.state.shop} />
              )}
            />
            <Route
              exact
              path="/shop-at/:shopName/:shopId/cart/"
              render={(props) => (
                <ShoppingCart
                  {...props}
                  updateShoppingCart={this.updateShoppingCart}
                  shoppingCart={this.state.shoppingCart}
                  shop={this.state.shop}
                />
              )}
            />
            <Route
              path="/shop-at/:shopName/:shopId/cart/add/"
              render={(props) => (
                <ShoppingCartQtyForm
                  {...props}
                  updateShoppingCart={this.updateShoppingCart}
                  shoppingCart={this.state.shoppingCart}
                  shop={this.state.shop}
                />
              )}
            />
          </div>

          <div>
            {this.state.shop ? (
              <div className="shopping-cart-btn">
                <Link
                  to={`/shop-at/${this.state.shop.name.replace(/\s+/g, "-")}/${
                    this.state.shop.id
                  }/cart/`}
                >
                  <img className="shopping-cart-img" src={logo} alt="" />
                </Link>
                {this.state.shoppingCart ? (
                  <div>
                    {this.state.shoppingCart.length > 0 ? (
                      <div className="cart-items-indicator is-round"></div>
                    ) : (
                      <span></span>
                    )}
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ) : (
              <div></div>
            )}
          </div>

          <div>
            {this.state.fetching ? (
              <div>
                <br />
                <Loading />
                <br />
              </div>
            ) : (
              <div></div>
            )}

            <BottomScrollListener
              onBottom={() => {
                if (this.state.nextFetch) {
                  this.fetchMoreProducts();
                }
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <br />
          <br />
          <br />
          <br />
          <Loading />
        </div>
      );
    }
  }

  async fetchShopDetails(shopId) {
    let fetchResult = await Ajax.fetchData(
      domain + "/en/api/shop/v1/details/?shop=" + shopId
    );
    if (fetchResult) {
      console.log(fetchResult);
      await this.setState({
        shopId: fetchResult.data.id,
        shop: fetchResult.data,
        ready: true,
      });

      this.fetchProducts();
    }
  }

  async componentDidMount() {
    let shopId = this.props.match.params.shopId;

    let urlState = this.props.location.state;
    console.log(urlState, "the url state");

    if (urlState) {
      if (urlState.shop) {
        await this.setState({
          shopId: urlState.shop.vehhealth_id
            ? urlState.shop.vehhealth_id
            : urlState.shop.id,
          shop: urlState.shop,
          ready: true,
        });
      } else if (urlState.product) {
        await this.setState({
          shopId: urlState.product.shop.id,
          shop: urlState.product.shop,
          ready: true,
        });
      }
    } else {
      console.log("no shop yet");
      await this.fetchShopDetails(shopId);
    }

    if (this.state.shopId) {
      await this.fetchProducts();
    }
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.state.initialFetchMade && this.state.shopId) {
      await this.fetchProducts();
    }

    this.checkQueryParams();
  }

  render() {
    return this.renderShopContent();
  }
}
